/* src/app/_shared/components/textarea/textarea.component.scss */
:host {
  --width: 100%;
  --height: 100%;
  display: block;
  width: var(--width);
  height: var(--height);
}
.flow-textarea {
  width: var(--width);
}
.flow-textarea label {
  display: block;
  margin: var(--input-label-margin);
  font-size: var(--input-label-font-size);
}
.flow-textarea .textarea-container {
  position: relative;
  width: var(--width);
}
.flow-textarea .textarea-container textarea {
  display: inline-block;
  width: var(--width);
  height: var(--height);
  padding: var(--input-padding);
  resize: none;
  border: 1px solid var(--ion-color-medium);
  border-radius: var(--radius);
  background-color: #FFFFFF;
  color: #444444;
  font-family: var(--font-family);
  font-size: var(--input-font-size);
}
.flow-textarea .textarea-container textarea:disabled {
  border-color: var(--ion-color-light);
  color: var(--ion-color-medium);
  background: #f5f4f4;
}
.flow-textarea .textarea-container textarea:not(:disabled):active,
.flow-textarea .textarea-container textarea:not(:disabled):focus,
.flow-textarea .textarea-container textarea:not(:disabled):hover {
  border-color: var(--ion-color-primary);
  outline: none;
}
.flow-textarea .textarea-container textarea:not(:disabled):active:read-only,
.flow-textarea .textarea-container textarea:not(:disabled):focus:read-only,
.flow-textarea .textarea-container textarea:not(:disabled):hover:read-only {
  border-color: var(--ion-color-light);
}
.flow-textarea .textarea-container textarea::placeholder {
  color: var(--ion-color-medium);
}
/*# sourceMappingURL=textarea.component-BJ7UPQCV.css.map */
